module.exports = __webpack_public_path__ + "media/src/fonts/Lora-Italic-4781a15318ddfb45b8a2051ad38c80f0.woff";